import React from 'react';

function ComponentHeader(props) {
  const { title, children ,className } = props;
  return (
    <div
      className={`${className} margin_bottom_20 d-flex justify-content-between flex-wrap align-items-center`}
      style={{ gap: '8px' }}
    >
      <h1 className='section_head'>{title}</h1>
      {children}
    </div>
  );
}

export default ComponentHeader;



// WEBPACK FOOTER //
// ./src/common/ComponentHeader.jsx